import React from "react";

const SIZE_CLASSES = {
  sm: "max-w-md",
  md: "max-w-lg",
  lg: "max-w-3xl",
  xl: "max-w-5xl",
};

// Generic overlay + panel wrapper, extracted from the hand-rolled modal
// markup repeated across pages/admin/Students.jsx. Renders a header bar with
// a title and close button, a scrollable body, and an optional footer.
const Modal = ({ title, subtitle, onClose, size = "md", footer, children }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className={`bg-white rounded-xl shadow-2xl w-full ${SIZE_CLASSES[size] || SIZE_CLASSES.md} max-h-[90vh] overflow-y-auto`}>
      <div className="sticky top-0 bg-indigo-600 px-6 py-4 rounded-t-xl flex items-center justify-between z-10">
        <div>
          <h3 className="text-lg font-bold text-white">{title}</h3>
          {subtitle && <p className="text-indigo-200 text-sm">{subtitle}</p>}
        </div>
        <button onClick={onClose} className="text-white text-2xl leading-none hover:text-indigo-200">
          ✕
        </button>
      </div>
      <div className="p-6">{children}</div>
      {footer && <div className="px-6 pb-5 flex justify-end gap-2">{footer}</div>}
    </div>
  </div>
);

export default Modal;
